import {useState} from 'react'

import Style from './style'
import MainHeader from 'widget/MainHeader'
import ITStyle from 'shared/style/inputTableStyle'
import usePostMyStoreManager from 'entity/franchise/usePostMyStoreManager'
import {pwRegx, nameRegx} from 'shared/lib/inputValidation'

const MyFranchiseStoreCreate = () => {
	const [formData, setFormData] = useState({
		name: '',
		contact: '',
		id: '',
		password: '',
		store_name: '',
		store_address: '',
	})

	const [errors, setErrors] = useState({})
	const [postStoreManager, isCreating] = usePostMyStoreManager()

	const handleInputChange = (field, value) => {
		setFormData((prev) => ({...prev, [field]: value}))
		if (errors[field]) {
			setErrors((prev) => ({...prev, [field]: ''}))
		}
	}

	const handleSubmit = () => {
		const newErrors = {}

		if (!formData.name) newErrors.name = '이름을 입력하세요'
		else if (!nameRegx.test(formData.name))
			newErrors.name = '한글 또는 영문으로 1-20자 이내로 입력하세요'

		if (!formData.id) newErrors.id = '아이디를 입력하세요'
		if (formData.id && (formData.id.length < 1 || formData.id.length > 20))
			newErrors.id = '1-20자 이내로 입력하세요'

		if (!formData.password) newErrors.password = '비밀번호를 입력하세요'
		else if (!pwRegx.test(formData.password))
			newErrors.password =
				'비밀번호는 6-20자 이내의 문자, 숫자, 특수문자를 각각 최소 1개 포함해야 합니다'

		if (!formData.store_name) newErrors.store_name = '매장명을 입력하세요'

		if (Object.keys(newErrors).length > 0) {
			setErrors(newErrors)
			return
		}

		const submitData = {
			id: formData.id,
			password: formData.password,
			name: formData.name,
			...(formData.contact ? {contact: formData.contact} : {}),
			store_name: formData.store_name,
			store_address: formData.store_address,
		}

		postStoreManager(submitData)
	}

	const btnList = [
		{
			label: '생성',
			clickEvent: handleSubmit,
			loading: isCreating,
		},
	]

	return (
		<Style.Wrapper>
			<MainHeader btnList={btnList} title='매장 매니저 계정 생성' />

			<ITStyle.TableDiv>
				<ITStyle.TableElement>
					<h2>
						이름<span>*</span>
					</h2>
					<Style.InputWrapper>
						<Style.Input
							placeholder='40자 이내로 입력하세요'
							value={formData.name}
							onChange={(e) => handleInputChange('name', e.target.value)}
						/>
						{errors.name && <Style.ErrorText>{errors.name}</Style.ErrorText>}
					</Style.InputWrapper>
				</ITStyle.TableElement>

				<ITStyle.TableElement>
					<h2>연락처</h2>
					<Style.InputWrapper>
						<Style.Input
							placeholder='010-0000-0000'
							value={formData.contact}
							onChange={(e) => handleInputChange('contact', e.target.value)}
						/>
					</Style.InputWrapper>
				</ITStyle.TableElement>

				<ITStyle.TableElement>
					<h2>
						아이디<span>*</span>
					</h2>
					<Style.InputWrapper>
						<Style.Input
							placeholder='로그인 아이디를 입력하세요'
							value={formData.id}
							onChange={(e) => handleInputChange('id', e.target.value)}
						/>
						{errors.id && <Style.ErrorText>{errors.id}</Style.ErrorText>}
					</Style.InputWrapper>
				</ITStyle.TableElement>

				<ITStyle.TableElement>
					<h2>
						비밀번호<span>*</span>
					</h2>
					<Style.InputWrapper>
						<Style.Input
							type='password'
							placeholder='6자 이상 입력하세요'
							value={formData.password}
							onChange={(e) => handleInputChange('password', e.target.value)}
						/>
						{errors.password && (
							<Style.ErrorText>{errors.password}</Style.ErrorText>
						)}
					</Style.InputWrapper>
				</ITStyle.TableElement>

				<ITStyle.TableElement>
					<h2>
						매장명<span>*</span>
					</h2>
					<Style.InputWrapper>
						<Style.Input
							placeholder='20자 이내로 입력하세요'
							value={formData.store_name}
							onChange={(e) => handleInputChange('store_name', e.target.value)}
						/>
						{errors.store_name && (
							<Style.ErrorText>{errors.store_name}</Style.ErrorText>
						)}
					</Style.InputWrapper>
				</ITStyle.TableElement>

				<ITStyle.TableElement>
					<h2>매장 주소</h2>
					<Style.InputWrapper>
						<Style.Input
							placeholder='40자 이내로 입력하세요'
							value={formData.store_address}
							onChange={(e) =>
								handleInputChange('store_address', e.target.value)
							}
						/>
					</Style.InputWrapper>
				</ITStyle.TableElement>
			</ITStyle.TableDiv>
		</Style.Wrapper>
	)
}

export default MyFranchiseStoreCreate
